import { ENV_CONFIG } from 'config/environment';
import { ImpactReportData } from 'store/impactReport/types';

// Slide 2's layers before its video: the last layer appears at ~27s and
// shows for 5s, then fades out for 1s, so the video starts at ~33s.
export const SLIDE_2_DURATION_MS = 32000;
// Covers the gap between SLIDE_2_DURATION_MS and when the video actually
// starts. Without it, the end of the video is cut off.
export const SLIDE_2_VIDEO_BUFFER_MS = 1500;

// Both are needed: without a duration Slide 2 isn't extended, so the video
// layer would only appear after the slide has ended.
export const hasVideo = (data: ImpactReportData | null | undefined): boolean =>
  !!data?.video && !!data?.video_duration_ms;

export const getVideoUrl = (video: string): string =>
  `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/impact_videos/${video}`;

export const getSlide2Duration = (data: ImpactReportData | null | undefined): number =>
  hasVideo(data)
    ? SLIDE_2_DURATION_MS + (data?.video_duration_ms ?? 0) + SLIDE_2_VIDEO_BUFFER_MS
    : SLIDE_2_DURATION_MS;
